module.exports = require('./helpers/bundle-url').getBundleURL('4afSR') + "chat_now.6ff90e1b.png";